export default __webpack_public_path__ + "static/media/noun-catalog-352895.91db805c.svg";